<div class="page">
  <app-page-header 
    itemName="" 
    page-title="{{ property.get('name') }}"
    isPropertyHome = "true"
    hideList = "{{ loggedUserShared }}"
  >
  </app-page-header>
  <div class="page-content">
    <div class="alert alert-danger text-center mb-4" *ngIf="propertyData && !propertyData.active">
      {{ 'properties.detail.suspended_property_alert' | translate }}
    </div>

    <!-- NOTES -->
    <div *ngIf="!loggedUserMaster && companyId !=='' && !masterOnlySuppliersAndNfcTag && !masterOnlySuppliers && !masterOnlyNfcTag" class=" mt-4">
      <app-platform-note-card [companyId]="companyId" [propertyId]="propertyId" [expanded]="true" #propertyNotes></app-platform-note-card>
    </div>

  </div> <!-- /.page-content -->
</div> <!-- /.page -->